<!-- 任务书图标 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 36.5">
    <title>任务书</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.9" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.9" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.38,5V3.56A2.57,2.57,0,0,0,27.92.89H7.58A2.57,2.57,0,0,0,5.13,3.56V20a2.57,2.57,0,0,0,2.45,2.67H27.92A2.57,2.57,0,0,0,30.38,20V13.23"
        />
        <line class="cls-3" x1="9.12" y1="26.7" x2="26.38" y2="26.7" />
        <ellipse class="cls-3" cx="16.09" cy="8.37" rx="3.36" ry="3.44" />
        <path class="cls-4" d="M10.49,18.12a5.6,5.6,0,1,1,11.19,0" />
        <line class="cls-3" x1="25.01" y1="9.3" x2="21.7" y2="18.03" />
        <ellipse class="cls-5" cx="30.35" cy="8.55" rx="1.35" ry="1.32" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 36.81">
    <title>任务书</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="28.21" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="28.21" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.38,5.28V3.87A2.57,2.57,0,0,0,27.92,1.2H7.58A2.57,2.57,0,0,0,5.13,3.87V20.29A2.57,2.57,0,0,0,7.58,23H27.92a2.57,2.57,0,0,0,2.46-2.67V13.54"
        />
        <line class="cls-3" x1="9.12" y1="27.02" x2="26.38" y2="27.02" />
        <ellipse class="cls-3" cx="16.09" cy="8.68" rx="3.36" ry="3.44" />
        <path class="cls-4" d="M10.49,18.43a5.6,5.6,0,1,1,11.19,0" />
        <line class="cls-3" x1="25.01" y1="9.61" x2="21.7" y2="18.34" />
        <ellipse class="cls-5" cx="30.35" cy="8.86" rx="1.35" ry="1.32" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 31.08">
    <title>任务书</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="22.48" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="22.48" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M27.84,4.41V3.22A2.17,2.17,0,0,0,25.77,1H8.61A2.17,2.17,0,0,0,6.53,3.22V17.07a2.17,2.17,0,0,0,2.08,2.26H25.77a2.17,2.17,0,0,0,2.07-2.26V11.38"
        />
        <line class="cls-3" x1="9.9" y1="22.75" x2="24.48" y2="22.75" />
        <ellipse class="cls-4" cx="15.79" cy="7.27" rx="2.83" ry="2.91" />
        <path class="cls-5" d="M11.06,15.51a4.73,4.73,0,1,1,9.45,0" />
        <line class="cls-6" x1="23.32" y1="8.06" x2="20.52" y2="15.43" />
        <ellipse class="cls-7" cx="27.91" cy="7.33" rx="1.04" ry="1.01" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3,
    .cls-4 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.78px;
    }
    .cls-4 {
      fill-rule: evenodd;
    }
    .cls-5 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3,
    .cls-4 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.4px;
    }
    .cls-4 {
      fill-rule: evenodd;
    }
    .cls-5 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6 {
      fill: none;
      stroke: #19a486;
      stroke-miterlimit: 10;
    }
    .cls-3,
    .cls-5,
    .cls-6 {
      stroke-linecap: round;
    }
    .cls-3 {
      stroke-width: 1.93px;
    }
    .cls-4,
    .cls-5,
    .cls-6 {
      stroke-width: 1.87px;
    }
    .cls-5 {
      fill-rule: evenodd;
    }
    .cls-7 {
      fill: #19a486;
    }
  }
</style>
